import { createApi } from '@reduxjs/toolkit/query/react';

import { likesSlice } from '@redux/state/likesSlice';

import { dynamicBaseQuery } from '../baseQuery';

export const likeApi = createApi({
  reducerPath: 'likeApi',
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    likeHost: builder.mutation<
      { count: number },
      { userId: string; showId: string; weight: number }
    >({
      query: ({ userId, showId, weight }) => ({
        url: '/like/host',
        method: 'POST',
        body: { userId, showId, weight },
      }),
      onQueryStarted: async (
        { showId, userId, weight },
        { dispatch, queryFulfilled },
      ) => {
        try {
          const { data } = await queryFulfilled;
          if (!data) {
            return;
          }
          dispatch(
            likesSlice.actions.setLikeByUser({
              showId,
              userId,
              data: {
                count: data.count,
                isLiked: weight === 1,
              },
            }),
          );
        } catch (error) {
          console.log('likeHost error:', error);
        }
      },
    }),
    likeSpeaker: builder.mutation<
      { count: number },
      { showId: string; userId: string; speakerId: string; weight: number }
    >({
      query: ({ showId, userId, speakerId, weight }) => ({
        url: '/like/speaker',
        method: 'POST',
        body: { showId, userId, speakerId, weight },
      }),
      onQueryStarted: async (
        { showId, speakerId, weight },
        { dispatch, queryFulfilled },
      ) => {
        try {
          const { data } = await queryFulfilled;
          if (!data) {
            return;
          }
          dispatch(
            likesSlice.actions.setLikeBySpeaker({
              showId,
              speakerId,
              data: {
                count: data.count,
                isLiked: weight === 1,
              },
            }),
          );
        } catch (error) {
          console.log('likeSpeaker error:', error);
        }
      },
    }),
  }),
});

export const { useLikeHostMutation, useLikeSpeakerMutation } = likeApi;
